import React from 'react';

import classes from './LoadingLayer.module.css';

const LoadingBlock = () => {
  return (
    <div className={classes.LoadingBlock}>
      <div className={classes.bg} />
      <div className={classes.chars_ctnr} >
        <img className={classes.chars} src={"data/images/LP_persos.png"} />
      </div>
      <div className={classes.logo} />
    </div>
  );
};

export default LoadingBlock;
